import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cards from '../../../Components/Cards/Cards';
import { getPercentageSafe } from '../../../Utils/MathUtils';
import Stats from '../../../Components/Stats/Stats';
import { isArrayEqual } from '../../../Utils/ArrayUtils';
import { MAX_RANGE, MIN_RANGE } from '../../../Utils/Constants';
import Trend from '../../../Components/Trend/Trend';
import { humanizeNumber } from '../../../Utils/NumberUtils';
import { SelectedAndTotal } from '../../../Components/SelectedAndTotal/SelectedAndTotal';

class SessionsStats extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    totalRegistrants: PropTypes.number,
    totalAttendees: PropTypes.number,
    totalSessions: PropTypes.number,
    selectedSessionsCount: PropTypes.number,
    selectedSession: PropTypes.shape({
      registrantCount: PropTypes.number,
      registrantsAttended: PropTypes.number
    }),
    trendData: PropTypes.shape({
      prevDateRange: PropTypes.shape({
        previousFromTime: PropTypes.string,
        previousToTime: PropTypes.string
      }),
      totalRegistrants: PropTypes.number,
      totalAttendees: PropTypes.number
    }),
    filter: PropTypes.shape({
      fromTime: PropTypes.string,
      toTime: PropTypes.string,
      registrantRange: PropTypes.array,
      attendeeRange: PropTypes.array,
      searchString: PropTypes.string
    }),
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired
    })
  };

  render() {
    let {
      totalRegistrants: registrantsCount = 0,
      totalAttendees: attendeeCount = 0,
      totalSessions: sessionCount = 0,
      isBig,
      selectedSession,
      selectedSessionsCount,
      mixpanelData
    } = this.props;

    let trendBeVisible = this.isTrendVisible();
    const { t } = this.context;

    let sessionsSubtext = t('header.cardTypes.totalSessions');
    if (selectedSessionsCount !== sessionCount) {
      sessionCount = selectedSessionsCount;
      sessionsSubtext = t('sessions.selectedSessionsTitle');
    }

    if (selectedSession && !isBig) {
      const { registrantCount = 0, registrantsAttended = 0 } = selectedSession;
      registrantsCount = registrantCount;
      attendeeCount = registrantsAttended;
      sessionCount = 1;
      sessionsSubtext = t('sessions.selectedSessionsTitle');
    }

    const currStats = {
      currDateRange: {
        fromTime: this.props.filter.fromTime,
        toTime: this.props.filter.toTime
      },
      registrants: registrantsCount,
      attendees: attendeeCount
    };

    const prevStats = {
      prevDateRange: {
        fromTime: this.props.trendData.prevDateRange.previousFromTime,
        toTime: this.props.trendData.prevDateRange.previousToTime
      },
      registrants: this.props.trendData.totalRegistrants,
      attendees: this.props.trendData.totalAttendees
    };

    let currAttendanceRate = getPercentageSafe(currStats.attendees, currStats.registrants);
    let previousAttendanceRate = getPercentageSafe(prevStats.attendees, prevStats.registrants);
    const cardArray = [
      {
        uniqueId: 'totalSessions',
        subText: sessionsSubtext,
        title: sessionCount,
        moreInfoTooltip: t('header.cardTypes.totalSessionsTooltip'),
        cardFooterComponent: isBig ? (
          <div className="statSelection">
            {t('tableTopStat.sessionsSelected', {
              selectedSessionsCount: selectedSessionsCount,
              totalSessionsCount: this.props.totalSessions
            })}
          </div>
        ) : (
          <div className="statSelection">
            <SelectedAndTotal
              totalRecords={this.props.totalSessions}
              selectedRecords={selectedSessionsCount}
              type={'sessions'}
            />
          </div>
        )
      },
      {
        uniqueId: 'registrants',
        subText: t('header.cardTypes.registrants'),
        title: humanizeNumber(registrantsCount),
        moreInfoTooltip: t('header.cardTypes.registrantsTooltip'),
        cardFooterComponent: trendBeVisible ? (
          <Trend
            title={t('header.cardTypes.registrants')}
            prevStats={{ prevDateRange: prevStats.prevDateRange, value: prevStats.registrants }}
            currentStats={{ currDateRange: currStats.currDateRange, value: currStats.registrants }}
            uniqueId={'registrants'}
            mixpanelData={mixpanelData}
          />
        ) : null
      },
      {
        uniqueId: 'attendees',
        subText: t('header.cardTypes.attendees'),
        title: humanizeNumber(attendeeCount),
        moreInfoTooltip: t('header.cardTypes.attendeesTooltip'),
        cardFooterComponent: trendBeVisible ? (
          <Trend
            title={t('header.cardTypes.attendees')}
            prevStats={{ prevDateRange: prevStats.prevDateRange, value: prevStats.attendees }}
            currentStats={{ currDateRange: currStats.currDateRange, value: currStats.attendees }}
            uniqueId={'attendees'}
            mixpanelData={mixpanelData}
          />
        ) : null
      },
      {
        uniqueId: 'attendanceRate',
        subText: t('tableHeaderColumns.attendanceRate'),
        title: `${currAttendanceRate}%`,
        moreInfoTooltip: t('header.cardTypes.attendanceRateTooltip'),
        cardFooterComponent: trendBeVisible ? (
          <Trend
            valuesArePercentages={true}
            title={t('tableHeaderColumns.attendanceRate')}
            prevStats={{ prevDateRange: prevStats.prevDateRange, value: previousAttendanceRate }}
            currentStats={{ currDateRange: currStats.currDateRange, value: currAttendanceRate }}
            uniqueId={'attendanceRate'}
            mixpanelData={mixpanelData}
          />
        ) : null
      }
    ];
    return <div>{isBig ? <Cards contents={cardArray} /> : <Stats contents={cardArray} />}</div>;
  }

  isTrendVisible = () => {
    let { registrantRange, attendeeRange, searchString } = this.props.filter;
    let isRegistrantArrayEqual = isArrayEqual(registrantRange, [MIN_RANGE, MAX_RANGE]);
    let isAttendeeArrayEqual = isArrayEqual(attendeeRange, [MIN_RANGE, MAX_RANGE]);
    let searchStringEqual = searchString.length > 0 ? false : true;
    return isRegistrantArrayEqual && isAttendeeArrayEqual && searchStringEqual;
  };
}
export default SessionsStats;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/Stats/SessionsStats.js